import React, { useState } from "react";
import "../../css_files/Ticket/TicketCard.css";

function TicketCard({ ticket, setTicketId, setshowticketpopup }) {
  const [showServiceInfo, setShowServiceInfo] = useState(false);

  return (
    <section className="ticket-card">
      <aside>
        <blockquote>
          <i
            className="fa-solid fa-ticket"
            onClick={() => {
              setshowticketpopup(true);
              setTicketId(ticket.seriesId);
            }}
            style={{ cursor: "pointer" }}
          ></i>
          <p>
            <strong>Ticket Id: </strong> <br /> {ticket.seriesId}
          </p>
          <p style={{ marginLeft: "auto" }}>
            <strong>Status: </strong>
            {ticket.status}
          </p>
        </blockquote>
        <blockquote>
          <i className="fa-solid fa-book"></i>
          <p>
            <strong>Linked to Enquiry Id: </strong>
            <br />
            {ticket.enquirySeriesId}
          </p>
        </blockquote>
        <blockquote style={{ justifyContent: "space-between" }}>
          <mark>
            <strong>Quotation Sent: </strong>
            <i
              className={`fa-solid ${
                ticket.isQuotationSent ? "fa-check" : "fa-xmark"
              }`}
            ></i>
          </mark>
          <mark>
            <strong>Order Created: </strong>
            <i
              className={`fa-solid ${
                ticket.isOrderCreated ? "fa-check" : "fa-xmark"
              }`}
            ></i>
          </mark>
        </blockquote>
        <blockquote>
          <mark>
            <i className="fa-solid fa-building"></i>
            <p>{ticket?.customer?.orgName}</p>
          </mark>
        </blockquote>
      </aside>

      <div>
        <blockquote>
          <i className="fa-solid fa-wrench"></i>
          <p>
            <strong>Service Information</strong>
          </p>
          <i
            className={`fa-solid ${
              showServiceInfo ? "fa-angle-up" : "fa-angle-down"
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => setShowServiceInfo(!showServiceInfo)}
          ></i>
        </blockquote>
        {showServiceInfo && (
          <blockquote>
            <p>
              <strong>Due Date: </strong>
              {new Date(ticket.serviceDetails.dueDate).toDateString()}
            </p>

            <p>
              <strong>Service Type: </strong>
              {ticket.serviceDetails.serviceType}
            </p>
            <p>
              <strong>Service Description: </strong>
              {ticket.serviceDetails.serviceDescription}
            </p>
          </blockquote>
        )}
      </div>
    </section>
  );
}

export default TicketCard;
